import React, { Component } from 'react';
import Actions from '~/Actions';
import { connect } from 'react-redux';
import { withStyles, Button, InputBase } from '@material-ui/core';
import { Lock } from '@mui/icons-material';
import { withRouter } from 'react-router-dom';
import common from '~/common';
import { re_psd } from '~/skills/TextRules';

const styles = theme => ({
  Row: { display: 'flex', fontSize: 16, letterSpacing: 0.1, alignItems: 'center' },
  Title: { width: 108, textAlign: 'end' },
  Input: { backgroundColor: 'white', width: 259, height: 42, fontSize: 16, letterSpacing: '0.15px', borderRadius: 14, border: '1px solid #E5E5E5', paddingLeft: 8, paddingRight: 8, marginLeft: 8 },
});

class ChangePsd extends Component {
  state={ passwd: '', passwd2: '', error: '', canSend: true, guideText: '' }
  componentDidMount () {
    this.token = this.props.match.params.token;
    this.props.getCurrentTokenAccount(this.token);
  }

  componentDidUpdate (preProps) {
    const { newPsd: preNewPsd = {} } = preProps;
    const { newPsd = {} } = this.props;
    if (Object.keys(preNewPsd).length === 0 && Object.keys(newPsd).length > 0 && newPsd.status !== '200') {
      this.setState({ canSend: true });
    }

    const { status: preStatus = '' } = preNewPsd;
    const { status = '' } = newPsd;
    if (preStatus !== status && status === '200' && !this.timer) {
      this.timer = setInterval(() => {
        this.second = this.second - 1;
        if (this.second >= 0) { this.setState({ guideText: `導向中...${this.second}` }); } else this.goBack();
      }, 1000);
      this.second = 3;
      this.setState({ guideText: `導向中...${this.second}` });
    }
  }

  componentWillUnmount () {
    const { clearPsdKey } = this.props;
    clearPsdKey('CurrentAccount');
    clearPsdKey('NewPsd');
    if (this.timer)clearInterval(this.timer);
  }

  send=() => {
    const { putNewPsd, currentAccount, clearPsdKey } = this.props;
    const { passwd, passwd2 } = this.state;
    const { data } = currentAccount;
    let account = '';
    if (typeof (data) === 'object' && data.account)account = data.account;
    let error = '';
    let canSend = true;
    clearPsdKey('NewPsd');
    if (passwd !== passwd2) error = '新密碼不一致。';
    else if (!re_psd(passwd))error = '密碼長度12-20碼，須包含大小寫英文字元、數字字元及符號字元。';
    else {
      canSend = false;
      putNewPsd({
        account,
        passwd,
        token: this.token,
      });
    }
    this.setState({ error, canSend });
  }

  goBack=() => { this.props.history.push(`${common.rootPath}/Login`); }

  render () {
    const { classes, currentAccount = {}, newPsd = {}, history } = this.props;
    const { passwd, passwd2, error, canSend: c, guideText } = this.state;
    const { data, status } = currentAccount;
    let account = '';
    if (typeof (data) === 'object' && data.account)account = data.account;
    const canSend = c && account.length > 0;
    const isActiveAct = history.location.pathname.match('/Login/ActiveAct/');
    return (currentAccount.status && status !== '200')
      ? (
        <div>
          <div style={{ marginTop: 130, marginRight: 12, marginLeft: 12 }}>{isActiveAct ? '連結已失效，請洽系統負責人。' : '連結已失效，請重新執行忘記密碼作業。' }</div>
          <Button style={{ marginTop: 120, width: 209, height: 48, borderRadius: 5, backgroundColor: '#6D3A89', color: 'white', fontSize: 16, letterSpacing: 0.1 }} onClick={this.goBack}>
            確認
          </Button>
        </div>
      )
      : (
        <div style={{ width: '100%', height: '100%', paddingTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Lock style={{ width: 20, height: 20 }} />
            <div style={{ marginLeft: 19, fontSize: 18, letterSpacing: 0.1 }}>密碼修改</div>
          </div>
          <div style={{ height: 35, fontSize: 12, color: 'red', display: 'flex', alignItems: 'end', justifyContent: 'center' }}>※請勿使用與工研院內AD相同帳號名使用密碼</div>
          <div className={classes.Row}>
            <div className={classes.Title}>帳號</div>
            <div style={{ paddingLeft: 26 }}>{account}</div>
          </div>
          <div style={{ height: 21 }} />
          <form>
            <div className={classes.Row}>
              <div className={classes.Title}>新密碼</div>
              <div style={{ color: '#F40000' }}>*</div>
              <InputBase
                className={classes.Input}
                placeholder="請輸入密碼"
                inputProps={{ height: 42 }}
                type="password"
                autoComplete='off'
                value={passwd}
                onChange={e => this.setState({ passwd: e.target.value })}
              />
            </div>
            <div style={{ height: 21 }} />
            <div className={classes.Row}>
              <div className={classes.Title}>確認新密碼</div>
              <div style={{ color: '#F40000' }}>*</div>
              <InputBase
                className={classes.Input}
                placeholder="請輸入密碼"
                inputProps={{ height: 42 }}
                type="password"
                autoComplete='off'
                value={passwd2}
                onChange={e => this.setState({ passwd2: e.target.value })}
              />
            </div>
          </form>

          <div style={{ minHeight: 30, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', color: 'red', marginRight: 12, marginLeft: 12 }}>
            {error.length > 0 && error}
            {newPsd.status === '200' && '密碼修改成功!'}
            {newPsd.status === '200' && <div style={{ marginLeft: 4, color: 'black' }}>{guideText}</div>}
            {Object.keys(newPsd).length > 0 && newPsd.status !== '200' && (newPsd.message || '密碼修改失敗')}
          </div>
          <div style={{ display: 'flex', paddingLeft: 304 }}>
            <div style={{ cursor: 'pointer', color: 'rgba(0, 0, 0, 0.54)', fontSize: 18, height: 24, textAlign: 'center' }} onClick={this.goBack}>返回登入頁</div>
          </div>
          <div style={{ height: 19 }} />
          <Button disabled={!canSend} style={{ width: 209, height: 48, borderRadius: 5, backgroundColor: canSend ? '#247690' : 'gray', color: 'white', fontSize: 16, letterSpacing: 0.1 }} onClick={this.send}>
            確認
          </Button>
        </div>
      );
  }
}
const mapStateToProps = state => ({
  currentAccount: state.PSD.CurrentAccount,
  newPsd: state.PSD.NewPsd,
});
const mapDispatchToProps = dispatch => ({
  getCurrentTokenAccount: token => Actions.getCurrentTokenAccount(dispatch, { token }),
  putNewPsd: body => Actions.putNewPsd(dispatch, { body }),
  clearPsdKey: key => Actions.clearPsdKey(dispatch, { key }),
});

export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePsd)));
